export const isInAppWebView = (): boolean => {

  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent;

  // Android WebView has tagged itself "; wv)" since KitKat. Older shells instead send a
  // "Version/x.y ... Chrome/" pair that Chrome for Android never sends on its own.
  if (/;\s*wv\)/.test(ua)) return true;
  if (/\bAndroid\b/.test(ua) && /\bVersion\/\d+(\.\d+)?\b/.test(ua)) return true;

  return /\b(iPhone|iPad|iPod)\b/.test(ua) && !/\bSafari\//.test(ua);

};
